import { createAsyncThunk } from '@reduxjs/toolkit';

import { selectUserActiveEmployerBusinessId } from 'store/user/selectors.js/user.selectors';
import { getProjectAssignments } from '../services/getProjectAssignments';

export const loadAssignmentsForProject = createAsyncThunk(
  'assignments/loadAssignmentsForProject',
  async (projectId, { getState }) => {
    const projectAssignments = await getProjectAssignments(
      projectId,
      selectUserActiveEmployerBusinessId(getState())
    );
    return projectAssignments;
  }
);
